import { DeleteIcon, EditIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import ConfirmDeleteDialog from '../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import { Quote, QuoteCompaisonColumnDatabase } from '../../../../types';
import QuoteFormDialog from '../QuoteFormDialog/QuoteFormDialog';
import { useQuoteMenuAction } from './useQuoteMenuAction';

type Props = {
  groupId: string;
  quote: Quote;
  columns: QuoteCompaisonColumnDatabase[];
};

export default function QuoteMenuAction(props: Props) {
  const hook = useQuoteMenuAction({ groupId: props.groupId, quoteId: props.quote.id });

  return (
    <>
      <ResourceMenuActions
        size="small"
        tooltip={`Options du devis ${props.quote.provider}`}
        actions={[
          { id: 'edit', label: 'Modifier', icon: <EditIcon fontSize="small" />, onClick: hook.handleOpenEdit },
          { id: 'delete', label: 'Supprimer', icon: <DeleteIcon fontSize="small" />, onClick: hook.handleOpenDelete },
        ]}
      />

      {hook.isEditOpen ? (
        <QuoteFormDialog
          groupId={props.groupId}
          columns={props.columns}
          quote={props.quote}
          onClose={hook.handleCloseEdit}
        />
      ) : null}

      {hook.isDeleteOpen ? (
        <ConfirmDeleteDialog
          title="Supprimer le devis"
          onConfirm={hook.handleConfirmDelete}
          onClose={hook.handleCloseDelete}
        >
          Supprimer le devis de « {props.quote.provider} » ?
        </ConfirmDeleteDialog>
      ) : null}
    </>
  );
}
